import React, {useEffect, useState} from "react";
import { isAuthenticated } from "./helper";
import { Link } from "react-router-dom";
import AppTheme from "../colors";
import $ from "jquery"
const Profile = () => {
    const theme = JSON.parse(localStorage.getItem("theme"));
    const currentTheme =  AppTheme["light"]
    // console.log(currentTheme);
    const [pics, setPics] = useState([])
    const {user, token} = isAuthenticated()
    const [image, setImage] = useState("")
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND}/mypost/${user._id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json() )
        .then(res => {
            console.log(res.mypost)
            setLoading(false)
            setPics(res.mypost)
        })
        .catch(err => console.log(err));

    }, [])

    useEffect(() => {
        if(image){
            const data = new FormData()
            data.append("file", image)
            data.append("upload_preset", "socioroorkee")
            data.append("cloud_name", "dhwaj")
            fetch("https://api.cloudinary.com/v1_1/dhwaj/image/upload", {
                method: "POST",
                body: data
            })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                
                fetch(`${process.env.REACT_APP_BACKEND}/user/${user._id}`, {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        pic: data.url
                    })
                })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                    var existing = JSON.parse(localStorage.getItem("jwt"));
                    existing.user.pic = data.pic;
                    localStorage.setItem("jwt", JSON.stringify(existing));
                    window.location.reload();
                })
            })
            .catch(err => console.log(err))
        }
    }, [image])

    const updatePhoto = (file) => {
        setImage(file);
    }   
    return (
        <div style={{backgroundColor: `${currentTheme.backgroundColor}`, color: `${currentTheme.textColor}` }}>
        <div className="row" >
            <div className="col s12">
            <div style={{maxWidth:"550px",margin:"10px auto"}}>
            <div style={{
                borderBottom: "1px solid grey"
            }}>
            
                <div style={{
                    display:"flex",
                    justifyContent:"space-around",
                }}>
                    <div>
                        <img style={{width: "120px", height: "120px", borderRadius:"80px"}} src={user.pic}/>
                    </div>
                    <div>
                        <h4 style={{textAlign: "center"}}>{user.name}   <span style={{color: "green"}}>{user.role === 1 ? '(admin)' : '' }</span></h4>
                        <div style={{display:"flex",justifyContent:"space-around",width:"100%"}}>
                           <h6 style={{ marginLeft: "5%", textAlign:"center"}}>{pics.length} Posts</h6>
                           <h6 style={{ marginLeft: "5%", textAlign:"center"}}>{user.followers.length} Followers</h6>
                           <h6 style={{ marginLeft: "5%", textAlign:"center"}}>{user.following.length} Following</h6>
                       </div>
                    </div>
                </div>
                    <button className="btn waves-effect waves-light #64b5f6 blue darken-1" style={{margin:"5% 0%", color: "white"}}>
                        <Link to="/updateprofile" className="white-text">Update Profile</Link>
                    </button>
                </div>
                
                    <div className="row">
                    {
                        pics.map(item => {
                            return(
                                <div className="col s6">
                                <Link to={`/post/${item._id}`}><img key={item._id}  style={{width: "100%", height: "100%"}} className="item" src={item.photo} alt={item.title}/></Link>
                                </div>
                            )
                        })
                    }
                    {loading && 
                        <div className="preloader-background">
                    <div class="preloader-wrapper big active" style={{backgroundColor: `${currentTheme.backgroundColor}`}}>
                        <div class="spinner-layer spinner-blue-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div><div class="gap-patch">
                            <div class="circle"></div>
                        </div><div class="circle-clipper right">
                            <div class="circle"></div>  
                        </div>
                        </div>
                    </div>
                    </div>
                    }
                    </div>
                
                
            </div>
            </div>
        </div>
        </div>
        
    )
}

export default Profile;